export enum Origin {
  WLV1 = "Frontend: WLv1",
}
